import { useRecoilState, useRecoilValue } from "recoil";
import { gradeState, semesterState } from "../../../../recoil/lesson/lessonState";
import React from "react";
import { curriculumState } from "../../../../recoil/curriculums/curriculumState";
import downIcon from "../../../../assets/images/classes/downIcon.svg";

const DropDownLessonGrade = ({ grade, setGrade, semester, setSemester, openDropdown, setOpenDropdown ,setLessonInfoId, setOnSelectGrade}) => {

    const curriculumData = useRecoilValue(curriculumState);

    const isOpen = openDropdown === "grade";

    const setGradeSemester = (item) => {
        setGrade(item.grade);
        setSemester(item.semester);
        setLessonInfoId(null);
        setOpenDropdown(null);
        setOnSelectGrade(true);
    };

    // console.log(grade);
    // console.log(semester);

    return (
        <div className="relative">
            <button
                onClick={() => setOpenDropdown(isOpen ? null : "grade")}
                className="inline-flex w-[152px] h-[44px] justify-center items-center gap-x-1.5 rounded-[10px] bg-white px-3 py-2 font-[500] text-[18px] text-[#000] shadow-custom ring-1 ring-inset ring-gray-300 hover:bg-gray-50 z-20 relative"
            >
                <div className="absolute left-0 right-0 text-center w-full pr-2">
                    {grade ? `${grade}학년` : "학년"} {semester ? `${semester}학기` : "학기"}
                </div>
                <img src={downIcon} alt="downIcon" className="ml-auto w-4" />
            </button>

            {isOpen && (
                <div className="absolute w-full z-10 origin-top rounded-b-[10px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden">
                    <div className="max-h-[300px] overflow-y-auto bg-[#F1F1F1]">
                        {curriculumData.lessonSemesterList.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => setGradeSemester(item)}
                                className="cursor-pointer hover:bg-blue-50 p-2"
                            >
                                {item.grade}학년 {item.semester}학기
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropDownLessonGrade;
